export default "__VITE_ASSET__CDuRF3W7__"